/**
 * 获取参数的类型小写字符串
 * @param x 任意类型参数
 */
export function getJStype(x) {
  return Object.prototype.toString.call(x).slice(8, -1).toLowerCase();
}
